// src/pages/Pims/pimsData.js
import { lazy } from 'react';

const PurchaseRequestsList = lazy(() => import("./PurchaseRequestsList/"));
// const PurchaseOrdersList = lazy(() => import("./PurchaseOrdersList"));
// const AcceptanceRecordsList = lazy(() => import("./AcceptanceRecordsList"));
// const Purchasers = lazy(() => import("./Purchasers"));

const ItemPrices = lazy(() => import("./ItemPrices"));
const Vendors = lazy(() => import("./Vendors"));

const InventoryList = lazy(() => import("./Inventory/InventoryList/"));
const InventoryRecords = lazy(() => import("./Inventory/InventoryRecords"));
const Stocktakes = lazy(() => import("./Inventory/Stocktakes"));
const Warehouse = lazy(() => import("./Inventory/Warehouse"));

export const INVENTORY_SUBMENU = [
  {
    path: '/pims/inventoryList',
    label: '庫存管理列表',
    component: InventoryList,
    addButtonText: '新增庫存',
    searchPlaceholder: '搜尋庫存商品編號、商品名稱...'
  },
  {
    path: '/pims/inventoryRecords',
    label: '出/入庫紀錄',
    component: InventoryRecords,
    addButtonText: '新增紀錄',
    searchPlaceholder: '搜尋紀錄編號、商品名稱...'
  },
  {
    path: '/pims/stocktakes',
    label: '盤點單列表',
    component: Stocktakes,
    addButtonText: '建立新盤點單',
    searchPlaceholder: '搜尋盤點單號、建立人員、倉庫...',
    // hidden: true,
  },
  // {
  //   path: '/pims/warehouse',
  //   label: '倉庫管理',
  //   component: Warehouse,
  //   addButtonText: '新增倉庫',
  //   searchPlaceholder: '搜尋倉庫編號、倉庫名稱...'
  // }
];

export const VISIBLE_INVENTORY_SUBMENU = INVENTORY_SUBMENU.filter(
  (item) => !item.hidden
);

export const DEFAULT_PATH = '/pims/vendors';

/** 請採驗列表／CustomPagination 共用每頁筆數選項（需搭配 showFullPageSizeOptionList，否則總筆數少時下拉會被過濾） */
export const PIMS_PAGE_SIZE_OPTIONS = ['10', '11', '15', '20', '25', '30', '50'];

/** 供應廠商管理列表：預設 12 筆，無 10 選項 */
export const PIMS_VENDORS_PAGE_SIZE_OPTIONS = ['12', '20', '25', '30', '50'];
export const PIMS_VENDORS_DEFAULT_PAGE_SIZE = 12;

/** 商品廠商價格列表：預設 12 筆，無 10 選項 */
export const PIMS_ITEM_PRICES_PAGE_SIZE_OPTIONS = ['12', '20', '25', '30', '50'];
export const PIMS_ITEM_PRICES_DEFAULT_PAGE_SIZE = 12;

/** 請購單列表：預設 11 筆，無 10、15 選項 */
export const PIMS_PURCHASE_REQUEST_PAGE_SIZE_OPTIONS = ['11', '20', '25', '30', '50'];
export const PIMS_PURCHASE_REQUEST_DEFAULT_PAGE_SIZE = 11;

/** 庫存管理列表：預設 12 筆，無 10、11、15 選項 */
export const PIMS_INVENTORY_LIST_PAGE_SIZE_OPTIONS = ['12', '20', '25', '30', '50'];
export const PIMS_INVENTORY_LIST_DEFAULT_PAGE_SIZE = 12;

/** 出/入庫紀錄列表：預設 12 筆，無 10 選項 */
export const PIMS_INVENTORY_RECORDS_PAGE_SIZE_OPTIONS = ['12', '20', '25', '30', '50'];
export const PIMS_INVENTORY_RECORDS_DEFAULT_PAGE_SIZE = 12;

/** 盤點單列表：預設 12 筆，無 10 選項 */
export const PIMS_STOCKTAKES_PAGE_SIZE_OPTIONS = ['12', '20', '25', '30', '50'];
export const PIMS_STOCKTAKES_DEFAULT_PAGE_SIZE = 12;

/** 出/入庫明細側欄：預設 10 筆，無 11、12 選項 */
export const PIMS_INVENTORY_RECORD_DETAIL_PAGE_SIZE_OPTIONS = ['10', '15', '20', '25', '30', '50'];
export const PIMS_INVENTORY_RECORD_DETAIL_DEFAULT_PAGE_SIZE = 10;

/** 列表載入骨架最多列數（與 pageSize 對齊但避免自訂超大筆數時卡頓） */
export const PIMS_LIST_SKELETON_ROW_CAP = 50;

/** 使用紀錄／出/入庫明細展開條碼：固定每頁 10 筆，僅頁碼與跳頁 */
export const PIMS_BARCODE_DETAIL_PAGE_SIZE = 10;

/** 庫存明細側欄：預設 13 筆，無 10、11、14、15 選項 */
export const PIMS_INVENTORY_DETAIL_STOCK_PAGE_SIZE_OPTIONS = ['13', '20', '25', '30', '50'];
export const PIMS_INVENTORY_DETAIL_STOCK_DEFAULT_PAGE_SIZE = 13;

/** 使用紀錄側欄：預設 11 筆，無 10 選項 */
export const PIMS_INVENTORY_DETAIL_USAGE_PAGE_SIZE_OPTIONS = ['10', '20', '25', '30', '50'];
export const PIMS_INVENTORY_DETAIL_USAGE_DEFAULT_PAGE_SIZE = 10;

export const breadcrumbsText = {
  pims: {
    value: "請採驗",
    purchaseRequestsList: { value: "請購單列表" },
    purchaseOrdersList: { value: "採購單列表" },
    acceptanceRecordsList: { value: "驗收單列表" },
    itemPrices: { value: "商品廠商價格" },
    vendors: { value: "廠商管理" },
    purchasers: { value: "採購人員管理" },
    inventory: {
      value: "庫存管理",
      inventoryList: { value: "庫存管理列表" },
      inventoryRecords: { value: "出/入庫紀錄" },
      stocktakes: { value: "盤點單列表" },
      warehouse: { value: "倉庫管理" }
    }
  }
};

export const getBreadcrumbs = (pathname) => {
  const paths = pathname.replace('/pims/', '');
  const rootPath = paths.split('/')[0];
  const crumbs = [{ text: breadcrumbsText?.pims?.value, href: '/pims' }];

  if (rootPath === 'inventoryList' || rootPath === 'inventoryRecords' || rootPath === 'stocktakes' || rootPath === 'warehouse') {
    crumbs.push(
      {
        text: breadcrumbsText?.pims?.inventory?.value,
        href: null
      },
      {
        text: breadcrumbsText?.pims?.inventory[rootPath]?.value || '',
        href: `/pims/${rootPath}`
      }
    );
  } else {
    crumbs.push({ text: breadcrumbsText.pims[paths]?.value || '', href: pathname });
  }

  return crumbs.filter(item => item?.text);
};

export const PIMS_MENU_ITEMS = [
  // { 
  //   path: '/pims/purchaseOrdersList',
  //   label: '採購單列表',
  //   component: PurchaseOrdersList,
  //   addButtonText: '新增採購單',
  //   searchPlaceholder: '搜尋採購單編號、採購人...'
  // },
  // { 
  //   path: '/pims/acceptanceRecordsList',
  //   label: '驗收單列表',
  //   component: AcceptanceRecordsList,
  //   addButtonText: '新增驗收單',
  //   searchPlaceholder: '搜尋驗收單編號、驗收人...'
  // },
  {
    path: '/pims/vendors',
    label: '廠商管理',
    component: Vendors,
    addButtonText: '新增廠商',
    searchPlaceholder: '搜尋廠商編號、廠商名稱、統一編號'
  },
  {
    path: '/pims/itemPrices',
    label: '商品廠商價格',
    component: ItemPrices,
    addButtonText: '新增商品',
    searchPlaceholder: '搜尋商品編號、名稱、聯絡人、供應商、分類、單位...'
  },
  { 
    path: '/pims/purchaseRequestsList',
    label: '請購單列表',
    component: PurchaseRequestsList,
    addButtonText: '新增請購單',
    searchPlaceholder: '搜尋請購單號、請購人員、分店、備註'
  },
  // { 
  //   path: '/pims/purchasers',
  //   label: '採購人員管理',
  //   component: Purchasers,
  //   addButtonText: '新增採購人員',
  //   searchPlaceholder: '搜尋採購人員編號、姓名...'
  // },
  {
    path: '/pims/inventory',
    label: '庫存管理',
    hasSubmenu: true,
    submenu: VISIBLE_INVENTORY_SUBMENU,
  }
];


// 新增函数：取得所有有效路徑
export const getAllValidPaths = () => {
  const mainPaths = PIMS_MENU_ITEMS.filter(item => !item.hasSubmenu).map(item => item.path);
  const subPaths = VISIBLE_INVENTORY_SUBMENU.map(item => item.path);
  return [...mainPaths, ...subPaths];
};

// 新增函数：檢查路徑是否有效
export const isValidPimsPath = (path) => {
  const validPaths = getAllValidPaths();
  
  // 0. 允許根路徑 /pims/ 作為有效路徑（會自動重新導向到預設頁面）
  if (path === '/pims' || path === '/pims/') {
    return true;
  }
  
  // 1. 直接匹配完整路径
  if (validPaths.includes(path)) {
    return true;
  }
  
  // 2. 檢查是否是有效主路徑的子路由，所有子路由直接通過
  for (const validPath of validPaths) {
    if (path.startsWith(validPath + '/')) {
      // 是子路由，直接回應有效
      return true;
    }
  }
  
  return false;
};

export const CITIES = [
  "臺北市", "新北市", "桃園市", "臺中市", "臺南市", "高雄市", "基隆市",
  "新竹市", "嘉義市", "新竹縣", "苗栗縣", "彰化縣", "南投縣", "雲林縣",
  "嘉義縣", "屏東縣", "宜蘭縣", "花蓮縣", "臺東縣", "澎湖縣", "金門縣", "連江縣"
];

export const PAYMENT_METHODS = ["轉帳匯款", "支票", "現金"];

const generateItemPricesId = (index) => {
  return `V${String(index + 1).padStart(4, '0')}`;
};

export const MOCK_ITEMS = Array(12).fill(null).map((_, index) => ({
  id: generateItemPricesId(index),
  name: '廠商名稱資訊股份有限公司',
  shortName: 'Yahoo商城',
  uniformNumber: '16195585',
  contact: '黃曉明',
  phone: '04-2224-6890',
  fax: '04-2224-6890',
  mobile: '0987654321',
  email: 'apamqwedfr@gmail.com',
  address: '400台北市中壢錦川里中山路43號1樓',
  standardName: '玻尿酸',
  productsName: '玻尿酸',
  category: '拉提耗材',
  inventoryUnit: '瓶',
  productSpecifications: 100,
  productPrices: 2000,
  lastUpdated: "2024/08/13 10:08:18",
  usageOptions: "不定量"
}));



export const MOCK_EDIT_RECORDS = [
  { year: "2024", date: "10-22", time: "20:40:33", name: "小林", actionType: "Edit", 
    editNote: "  目前資料的 .editNote 備註" },
  { year: "2024", date: "08-22", time: "20:40:33", name: "小林", actionType: "Edit", 
    editNote: "反正又改了" },
  { year: "2024", date: "08-21", time: "18:22:33", name: "小米", actionType: "Edit", 
    editNote: "修改公司名稱" },
  { year: "2024", date: "08-20", time: "18:10:13", name: "小花", actionType: "Create", 
    editNote: "快樂創建"  } // vendor?.editNote || itemPrices?.editNote || "無備註" }
]

// 請購單簽核狀態
export const PURCHASE_REQUEST_STATUS = {
  DRAFT: 'draft',                   // 草稿（步驟 1）
  PENDING: 'pending',               // 待初審（步驟 2）
  FIRST_REVIEW_PASSED: 'first_review_passed', // 待複審（步驟 3，後端 statusId 8）
  APPROVED: 'approved',             // 審核通過 - 待出貨（步驟 4）
  REJECTED: 'rejected',             // 未通過（後端 statusId 7；篩選「全部未通過」）
  /** 僅前端篩選用，後端無獨立 statusId；搭配列資料 rejectReviewPhase */
  REJECTED_FIRST_REVIEW: 'rejected_first',
  REJECTED_SECOND_REVIEW: 'rejected_second',
  SHIPPED: 'shipped',               // 已出貨 - 待入庫（步驟 5）
  RECEIVING: 'receiving',           // 入庫中（步驟 6）
  COMPLETED: 'completed',           // 已完成（步驟 7）
};

export const PURCHASE_REQUEST_STATUS_LABEL = {
  [PURCHASE_REQUEST_STATUS.DRAFT]: '草稿',
  [PURCHASE_REQUEST_STATUS.PENDING]: '待初審',
  [PURCHASE_REQUEST_STATUS.FIRST_REVIEW_PASSED]: '待複審',
  [PURCHASE_REQUEST_STATUS.APPROVED]: '待出貨',
  [PURCHASE_REQUEST_STATUS.REJECTED]: '未通過',
  [PURCHASE_REQUEST_STATUS.REJECTED_FIRST_REVIEW]: '初審未通過',
  [PURCHASE_REQUEST_STATUS.REJECTED_SECOND_REVIEW]: '複審未通過',
  [PURCHASE_REQUEST_STATUS.SHIPPED]: '待入庫',
  [PURCHASE_REQUEST_STATUS.RECEIVING]: '入庫中',
  [PURCHASE_REQUEST_STATUS.COMPLETED]: '已完成',
};

// 請購單假資料
const generatePurchaseRequestId = (index) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `PR-${year}${month}${day}-${String(index + 1).padStart(3, '0')}`;
};

const MOCK_BRANCHES = ['美學-南京店', '美學-台中店', '美學-高雄店', '美學-新竹店', '美學-台南店'];
const MOCK_REQUESTERS = ['Seven Lai', '小米', '小林', '王小明', '陳小華', '李大偉'];
const MOCK_NOTES = [
  '熊貓針30/耗材例行請',
  '玻尿酸補貨申請',
  '肉毒桿菌素月度補貨',
  '美白針劑定期請購',
  '雷射耗材緊急補貨',
  '皮秒耗材申請',
];

const statuses = [
  PURCHASE_REQUEST_STATUS.DRAFT,              // 草稿
  PURCHASE_REQUEST_STATUS.PENDING,            // 待初審
  PURCHASE_REQUEST_STATUS.FIRST_REVIEW_PASSED, // 待複審
  PURCHASE_REQUEST_STATUS.APPROVED,           // 待出貨
  PURCHASE_REQUEST_STATUS.REJECTED,           // 未通過
  PURCHASE_REQUEST_STATUS.SHIPPED,            // 待入庫
  PURCHASE_REQUEST_STATUS.RECEIVING,          // 入庫中
  PURCHASE_REQUEST_STATUS.COMPLETED,          // 已完成
];

export const MOCK_PURCHASE_REQUESTS = Array(25).fill(null).map((_, index) => {
  const randomDate = new Date();
  randomDate.setDate(randomDate.getDate() - Math.floor(Math.random() * 30));
  
  return {
    id: index + 1,
    requestNumber: generatePurchaseRequestId(index),
    branch: MOCK_BRANCHES[index % MOCK_BRANCHES.length],
    requestDate: randomDate.toLocaleString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).replace(/\//g, '/'),
    requester: MOCK_REQUESTERS[index % MOCK_REQUESTERS.length],
    quantity: Math.floor(Math.random() * 50) + 10,
    status: statuses[index % statuses.length],
    notes: MOCK_NOTES[index % MOCK_NOTES.length],
  };
});

// 請購單流程步驟
export const PURCHASE_REQUEST_STEPS = [
  { key: 1, label: '草稿' },
  { key: 2, label: '初審通過', pendingLabel: '待初審', failedLabel: '初審未通過' },
  { key: 3, label: '複審通過', pendingLabel: '待複審', failedLabel: '複審未通過' },
  { key: 4, label: '待出貨' },
  { key: 5, label: '待入庫' },
  { key: 6, label: '入庫中' },
  { key: 7, label: '請購單完成' },
];

// 低於安全庫存的商品假資料
const MOCK_WAREHOUSES = ['小巨蛋倉', '中山倉', '南京倉', '贈品倉'];

export const MOCK_LOW_STOCK_PRODUCTS = [
  {
    id: 1,
    productCode: 'PP001',
    productName: '玻尿酸 100ml',
    brandProductCategoryName: '美容耗材',
    inventoryUnit: '瓶',
    specification: '100 ml',
    currentQuantity: 34,
    alertQuantity: 50,
    warehouseName: '小巨蛋倉',
    warehouseId: 1,
  },
  {
    id: 2,
    productCode: 'PP001',
    productName: '玻尿酸 100ml',
    brandProductCategoryName: '美容耗材',
    inventoryUnit: '瓶',
    specification: '100 ml',
    currentQuantity: 34,
    alertQuantity: 50,
    warehouseName: '中山倉',
    warehouseId: 2,
  },
  {
    id: 3,
    productCode: 'PP002',
    productName: 'OBT女神玻尿酸',
    brandProductCategoryName: '美容耗材',
    inventoryUnit: '支',
    specification: '1 支',
    currentQuantity: 5,
    alertQuantity: 20,
    warehouseName: '中山倉',
    warehouseId: 2,
  },
  {
    id: 4,
    productCode: 'PP003',
    productName: 'Juvelook喬雅露',
    brandProductCategoryName: '美容耗材',
    inventoryUnit: '瓶',
    specification: '1 瓶',
    currentQuantity: 3,
    alertQuantity: 10,
    warehouseName: '南京倉',
    warehouseId: 3,
  },
  {
    id: 5,
    productCode: 'PP004',
    productName: '外用藥膏',
    brandProductCategoryName: '美容耗材',
    inventoryUnit: '條',
    specification: '1條',
    currentQuantity: 1,
    alertQuantity: 5,
    warehouseName: '贈品倉',
    warehouseId: 4,
  },
];

const generateVendorId = (index) => {
  return `V${String(index + 1).padStart(4, '0')}`;
};

export const MOCK_VENDORS = (user = "未知的某人") => Array(12).fill(null)
.map((_, index) => ({
  id: generateVendorId(index),
  name: `廠商名稱資訊${index + 1}股份有限公司`,
  shortName: `Yahoo商城${index + 1}`,
  uniformNumber: `1619${String(index + 1).padStart(4, '0')}`,
  contact: `黃曉明${index + 1}`,
  phone: '04-2224-6890',
  fax: '04-2224-6890',
  mobile: `098765${String(index + 1).padStart(4, '0')}`,
  email: `apamq${index + 1}@gmail.com`,
  address: `${400 + index}台北市中壢錦川里中山路${index + 1}號1樓`,
  city: '臺北市',
  postalCode: String(400 + index),
  targetAmount: '3,000,000',
  exemptAmount: '10,000',
  bankName: '上海商業銀行',
  branchName: '南京分行',
  bankCode: '112',
  accountNumber: `12345${String(index + 1).padStart(4, '0')}`,
  accountName: `廠商名稱資訊${index + 1}有限公司`,
  country: '台灣(TW)',
  paymentMethod: '轉帳匯款',
  notes: `廠商${index + 1}的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡廠商1的備註寫在這裡`,
  // items
  standardName: '玻尿酸',
  productsName: '玻尿酸',
  category: '拉提耗材',
  inventoryUnit: '瓶',
  productSpecifications: 100,
  productPrices: 2000,
  lastUpdated: "2024/08/13 10:08:18",
  bankImage: "https://i.imgur.com/koqxzFM.jpeg",
  //編輯備註
  editNote: `這是編輯發言，我是 ${user} 修改了廠商${index + 1}在${new Date().toLocaleDateString()}修改了資料`
}));
